import React, { createRef, useEffect, useRef, useState } from "react";
import { BiImageAdd } from "react-icons/bi";
import { Button, Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { CanvasStage } from "../components/components/christmasCard/stage";
import { Upload } from "../components/components/christmasCard/upload";
import { IconManager } from "../components/components/christmasCard/icons";
import { StickerManager } from "../components/components/christmasCard/stickers";
import useImage from "use-image";
import logoColombina from "../assets/home/logo_col.png";
import logoColombinaENG from "../assets/home/LOGO_COL_ENG.png";
import { CustomTextManager } from "../components/components/christmasCard/textInput";
import ecard from "../assets/christmasCard/CINTA_ECARD.png";
import tituloSabor from "../assets/christmasCard/TITULO_SABORQUETEACA.png";
import tituloSaborEn from "../assets/christmasCard/TITULO_SABORQUETEACA_EN.png";
import mtnIzq from "../assets/christmasCard/backgrounds/MONTANA_IZQUIERDA.png";
import mtnDer from "../assets/christmasCard/backgrounds/MONTANA_DERECHA.png";
import renoGif from "../assets/christmasCard/RENO-ANIMADO.gif";
import pinguinoGif from "../assets/christmasCard/PINGUINO-SKY-ft.gif";

//IMPORT IMAGENES PARA PERSONAJES
import zorro from "../assets/christmasCard/avatares/ZORRO.png";
import pinguino from "../assets/christmasCard/avatares/PINGUINO.png";
import reno from "../assets/christmasCard/avatares/RENO_COMPLETO.png";
import oso from "../assets/christmasCard/avatares/OSO.png";

//IMPORT IMAGENES PARA STICKERS
import gafas from "../assets/christmasCard/stickers/STICKER_GAFAS.png";
import bolas from "../assets/christmasCard/stickers/STICKER_BOLAS.png";
import gorro from "../assets/christmasCard/stickers/STICKER_GORRO.png";
import regalo from "../assets/christmasCard/stickers/STICKER_REGALO.png";

//IMPORT IMAGENES PARA FONDOS
import fondo1Import from "../assets/christmasCard/cardBackgrounds/01.png";
import fondo2Import from "../assets/christmasCard/cardBackgrounds/02.png";
import fondo3Import from "../assets/christmasCard/cardBackgrounds/03.png";
import fondo4Import from "../assets/christmasCard/cardBackgrounds/04.png";
import fondo1ImportEng from "../assets/christmasCard/cardBackgrounds/01-eng.png";
import fondo2ImportEng from "../assets/christmasCard/cardBackgrounds/02-eng.png";
import fondo3ImportEng from "../assets/christmasCard/cardBackgrounds/03-eng.png";
import fondo4ImportEng from "../assets/christmasCard/cardBackgrounds/04-eng.png";
import fondo1ImportPre from "../assets/christmasCard/cardBackgrounds/pre-01.png";
import fondo2ImportPre from "../assets/christmasCard/cardBackgrounds/pre-02.png";
import fondo3ImportPre from "../assets/christmasCard/cardBackgrounds/pre-03.png";
import fondo4ImportPre from "../assets/christmasCard/cardBackgrounds/pre-04.png";
import fondo1ImportPreEng from "../assets/christmasCard/cardBackgrounds/pre-eng-01.png";
import fondo2ImportPreEng from "../assets/christmasCard/cardBackgrounds/pre-eng-02.png";
import fondo3ImportPreEng from "../assets/christmasCard/cardBackgrounds/pre-eng-03.png";
import fondo4ImportPreEng from "../assets/christmasCard/cardBackgrounds/pre-eng-04.png";

import { BackGroundManager } from "../components/components/christmasCard/backgroundSelector";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { ModalCompartir } from "../components/components/modalCompartir";

export const ChristmasCard = ({ language }) => {
  const [width, setWidth] = useState(100);
  const [height, setHeight] = useState(100);
  const intl = useIntl();

  const imageRef = useRef();

  //HOOK PARA MANEJO DE IMAGEN DEL USUARIO
  const [showImage, setShowImage] = useState(false);
  const [uploadedImage, setUploadedImage] = useState();
  const [image] = useImage(uploadedImage, "Anonymous");
  const [imgHeight, setImgHeight] = useState(100);
  const [imgWidth, setImgWidth] = useState(100);
  const [imgX, setImgX] = useState(10);
  const [imgY, setImgY] = useState(100);

  //HOOKS PARA EL MANEJO DE LOS PERSONAJES
  const [showZorro, setShowZorro] = useState(false);
  const [showOso, setShowOso] = useState(false);
  const [showReno, setShowReno] = useState(false);
  const [showPinguino, setShowPinguino] = useState(false);
  const [zorroImg] = useImage(zorro, "Anonymous");
  const [pinguinoImg] = useImage(pinguino, "Anonymous");
  const [osoImg] = useImage(oso, "Anonymous");
  const [renoImg] = useImage(reno, "Anonymous");

  const [personajeX, setPersonajeX] = useState(0);
  const [personjeY, setPersonajeY] = useState(25);

  //HOOKS PARA EL MANEJO DE LOS STICKERS
  const [showBolas, setShowBolas] = useState(false);
  const [showGafas, setshowGafas] = useState(false);
  const [showGorro, setshowGorro] = useState(false);
  const [showRegalo, setshowRegalo] = useState(false);
  const [bolasImg] = useImage(bolas, "Anonymous");
  const [gafasImg] = useImage(gafas, "Anonymous");
  const [gorroImg] = useImage(gorro, "Anonymous");
  const [regaloImg] = useImage(regalo, "Anonymous");
  const [stickerX, setStickerX] = useState(0);
  const [stickerY, setStickery] = useState(150);

  //HOOKS PARA MANEJO DE TEXTOS DE LA TARJETA
  const [msjNavidad, setMsjNavidad] = useState("");
  const [showMsjNavidad, setShowMsjNavidad] = useState(false);
  const [msjNavidadFont, setMsjNavidadFont] = useState("arial");
  const [msjNavidadColor, setMsjNavidadColor] = useState("#000000");
  const [msjNavidadSize, setMsjNavidadSize] = useState(20);
  const [msjNavidadX, setMsjNavidadX] = useState(50);
  const [msjNavidadY, setMsjNavidadY] = useState(300);

  const [msjDe, setMsjDe] = useState("");
  const [showMsjDe, setShowMsjDe] = useState(false);
  const [msjDeColor, setMsjDeColor] = useState("#000000");
  const [msjDeSize, setMsjDeSize] = useState(14);
  const [msjDeFont, setMsjDeFont] = useState("arial");
  const [msjDeX, setMsjDedX] = useState(150);
  const [msjDeY, setMsjDeY] = useState(400);

  const [msjPara, setMsjPara] = useState("");
  const [showMsjPara, setShowMsjPara] = useState(false);
  const [msjParaColor, setMsjParaColor] = useState("#000000");
  const [msjParaSize, setMsjParaSize] = useState(14);
  const [msjParaFont, setMsjParaFont] = useState("arial");
  const [msjParaX, setMsjParaX] = useState(50);
  const [msjParaY, setMsjParaY] = useState(450);

  //HOOKS PARA EL MANEJOS DE LOS FONDOS
  const [indexFondo, setindexFondo] = useState(1);
  const [fondo1] = useImage(fondo1Import, "Anonymous");
  const [fondo1Eng] = useImage(fondo1ImportEng, "Anonymous");
  const [fondo2] = useImage(fondo2Import, "Anonymous");
  const [fondo2Eng] = useImage(fondo2ImportEng, "Anonymous");
  const [fondo3] = useImage(fondo3Import, "Anonymous");
  const [fondo3Eng] = useImage(fondo3ImportEng, "Anonymous");
  const [fondo4] = useImage(fondo4Import, "Anonymous");
  const [fondo4Eng] = useImage(fondo4ImportEng, "Anonymous");

  //HOOKS PARA MANEJO DE FONDOS PREDETERMINADOS
  const [fondo1Pre] = useImage(fondo1ImportPre, "Anonymous");
  const [fondo2Pre] = useImage(fondo2ImportPre, "Anonymous");
  const [fondo3Pre] = useImage(fondo3ImportPre, "Anonymous");
  const [fondo4Pre] = useImage(fondo4ImportPre, "Anonymous");
  const [fondo1PreEng] = useImage(fondo1ImportPreEng, "Anonymous");
  const [fondo2PreEng] = useImage(fondo2ImportPreEng, "Anonymous");
  const [fondo3PreEng] = useImage(fondo3ImportPreEng, "Anonymous");
  const [fondo4PreEng] = useImage(fondo4ImportPreEng, "Anonymous");

  //HOOK PARA MANEJAR MOSTRAR O NO EL CANVAS
  const [showCanvas, setShowCanvas] = useState(false);
  const [selectedId1, selectShape1] = useState(null);
  const [unselected, setunselected] = useState(true);

  //HOOK PARA manejar imagen de render en el componente de compartir
  const [preRenderImg, setPrerenderImg] = useState(null);

  useEffect(() => {
    if (showCanvas) {
      const resizeObserver = new ResizeObserver((event) => {
        // Depending on the layout, you may need to swap inlineSize with blockSize
        // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
        setWidth(event[0].contentBoxSize[0].inlineSize);
        setHeight(event[0].contentBoxSize[0].blockSize);
      });
      resizeObserver.observe(document.getElementById("divCanvas"));
    }
  }, [showCanvas]);
  useEffect(() => {
    if (language.includes("en") && msjDe === "Remitente") {
      setMsjDe("From");
    }
    if (language.includes("es") && msjDe === "From") {
      setMsjDe("Remitente");
    }
    if (language.includes("en") && msjPara === "Destinatario") {
      setMsjPara("To");
    }
    if (language.includes("es") && msjDe === "To") {
      setMsjPara("Destinatario");
    }
    if (language.includes("en") && msjNavidad === "Mensaje de Navidad") {
      setMsjNavidad("Christmas Message");
    }
    if (language.includes("es") && msjDe === "Christmas Message") {
      setMsjNavidad("Mensaje de Navidad");
    }
  }, [language]);

  //FUCION QUE RETORNA EL FONDO DEL CANVA CON BASE EN EL INDEX SELECCIONADO
  function returnFondo(indice) {
    switch (indice) {
      case 1:
        return language.includes("es") ? fondo1Pre : fondo1PreEng;
      case 2:
        return language.includes("es") ? fondo2Pre : fondo2PreEng;
      case 3:
        return language.includes("es") ? fondo3Pre : fondo3PreEng;
      case 4:
        return language.includes("es") ? fondo4Pre : fondo4PreEng;
      case 5:
        return language.includes("es") ? fondo1 : fondo1Eng;
      case 6:
        return language.includes("es") ? fondo2 : fondo2Eng;
      case 7:
        return language.includes("es") ? fondo3 : fondo3Eng;
      case 8:
        return language.includes("es") ? fondo4 : fondo4Eng;
      default:
        return null;
    }
  }

  //METODOS PARA DESCARGA DE TARJETA
  const downloadURI = (uri, name) => {
    const link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = () => {
    const dataURL = imageRef.current.toDataURL({ pixelRatio: 4 });
    downloadURI(dataURL, "ChristmasCard.png");
  };

  function getUri() {
    selectShape1(null);
    setTimeout(function () {
      imageRef.current.toImage({
        callback(img) {
          setPrerenderImg(img);
        },
      });
    }, 0);
  }
  function startOver() {
    setindexFondo(1);
    setShowZorro(false);
    setShowOso(false);
    setShowPinguino(false);
    setShowReno(false);
    setShowMsjDe(false);
    setShowMsjPara(false);
    setShowMsjNavidad(false);
    setShowBolas(false);
    setshowGafas(false);
    setshowGorro(false);
    setshowRegalo(false);
    setShowImage(false);
    setMsjNavidad("Mensaje de Navidad");
    setMsjDe("Remitente");
    setMsjPara("Destinatario");
  }

  return (
    <>
      <div className="christmasCard">
        <img
          src={renoGif}
          alt="gif matas brillantes"
          className="christmasCard__renoFondo"
        />
        <img
          src={pinguinoGif}
          alt="gif matas brillantes"
          className="christmasCard__pinguinoFondo"
        />
        {/* <img
          src={language.includes("es") ? logoColombina : logoColombinaENG}
          className="christmasCard__mainLogo"
          alt="logo campaña colombina"
        /> */}

        <div className="christmasCard__mainDiv">
          <Container className="christmasCard__mainContainer">
            <Row className="christmasCard__mainRow">
              <Col xs={12} sm={7} style={{ zIndex: 4 }}>
                <Row>
                  <div className="christmasCard__titleDiv">
                    <img
                      src={
                        language.includes("es") ? tituloSabor : tituloSaborEn
                      }
                      alt="eCard icon"
                      className="christmasCard__tituloImage"
                    ></img>
                  </div>
                </Row>
                <Row>
                  <Col xs={{ span: 12 }}>
                    <Tabs
                      defaultActiveKey="fondos"
                      className="mb-4 christmasCard__tabs"
                      fill
                    >
                      <Tab
                        eventKey="fondos"
                        title={intl.formatMessage({ id: "background" })}
                      >
                        <BackGroundManager
                          setIndex={setindexFondo}
                          index={indexFondo}
                          setShowCard={setShowCanvas}
                          language={language}
                        />
                      </Tab>
                      <Tab
                        eventKey="textos"
                        title={intl.formatMessage({ id: "text" })}
                      >
                        <CustomTextManager
                          msjNavidad={msjNavidad}
                          msjDe={msjDe}
                          msjPara={msjPara}
                          setMsjNavidad={setMsjNavidad}
                          setMsjDe={setMsjDe}
                          setMsjPara={setMsjPara}
                          showMsjNavidad={showMsjNavidad}
                          showMsjDe={showMsjDe}
                          showMsjPara={showMsjPara}
                          setShowMsjNavidad={setShowMsjNavidad}
                          setShowMsjDe={setShowMsjDe}
                          setShowMsjPara={setShowMsjPara}
                          msjNavidadColor={msjNavidadColor}
                          setMsjNavidadColor={setMsjNavidadColor}
                          setMsjDeColor={setMsjDeColor}
                          setMsjParaColor={setMsjParaColor}
                          msjNavidadSize={msjNavidadSize}
                          setMsjNavidadSize={setMsjNavidadSize}
                          msjDeSize={msjDeSize}
                          setMsjDeSize={setMsjDeSize}
                          msjParaSize={msjParaSize}
                          setMsjParaSize={setMsjParaSize}
                          msjNavidadFont={msjNavidadFont}
                          setMsjNavidadFont={setMsjNavidadFont}
                          msjDeFont={msjDeFont}
                          setMsjDeFont={setMsjDeFont}
                          msjParaFont={msjParaFont}
                          setMsjParaFont={setMsjParaFont}
                        />
                      </Tab>
                      <Tab
                        eventKey="personajes"
                        title={intl.formatMessage({ id: "characters" })}
                      >
                        <IconManager
                          oso={showOso}
                          setOso={setShowOso}
                          zorro={showZorro}
                          setZorro={setShowZorro}
                          pinguino={showPinguino}
                          setPinguino={setShowPinguino}
                          reno={showReno}
                          setReno={setShowReno}
                        />
                      </Tab>
                      <Tab
                        eventKey="stickers"
                        title={intl.formatMessage({ id: "stickers" })}
                      >
                        <StickerManager
                          bolas={showBolas}
                          setBolas={setShowBolas}
                          gafas={showGafas}
                          setGafas={setshowGafas}
                          gorro={showGorro}
                          setGorro={setshowGorro}
                          regalo={showRegalo}
                          setRegalo={setshowRegalo}
                        />
                      </Tab>
                    </Tabs>
                  </Col>
                </Row>
                <Row
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <Col
                    xs={12}
                    lg={6}
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      padding: "1vh 1vw",
                    }}
                  >
                    <ModalCompartir
                      downloadCanvas={handleDownload}
                      preRenderImg={preRenderImg}
                      getUri={getUri}
                      language={language}
                      showCanvas={showCanvas}
                      de={msjDe}
                      para={msjPara}
                      indiceFondo={indexFondo}
                    />
                  </Col>
                  <Col
                    xs={12}
                    lg={6}
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      padding: "1vh 1vw",
                    }}
                  >
                    <Button
                      className="christmasCard__botonInputRestart"
                      onClick={() => {
                        startOver();
                      }}
                    >
                      <FormattedMessage id="startOver" />
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={5} style={{ zIndex: 4 }}>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  {showCanvas ? (
                    <div className="christmasCard__stageCanvas" id="divCanvas">
                      <CanvasStage
                        stageRef={imageRef}
                        width={width}
                        heigth={height}
                        image={image}
                        imageHeight={imgHeight}
                        imageWidth={imgWidth}
                        imgX={imgX}
                        imgY={imgY}
                        showImage={showImage}
                        zorroImg={zorroImg}
                        showZorro={showZorro}
                        pinguinoImg={pinguinoImg}
                        showPinguino={showPinguino}
                        osoImg={osoImg}
                        showOso={showOso}
                        renoImg={renoImg}
                        showReno={showReno}
                        personajeX={personajeX}
                        personajeY={personjeY}
                        bolasImg={bolasImg}
                        showBolas={showBolas}
                        gafasImg={gafasImg}
                        showGafas={showGafas}
                        gorroImg={gorroImg}
                        showGorro={showGorro}
                        regaloImg={regaloImg}
                        showRegalo={showRegalo}
                        stickerX={stickerX}
                        stickerY={stickerY}
                        msjNavidad={msjNavidad}
                        msjDe={msjDe}
                        msjPara={msjPara}
                        showMsjNavidad={showMsjNavidad}
                        showMsjDe={showMsjDe}
                        showMsjPara={showMsjPara}
                        fondo={returnFondo(indexFondo)}
                        msjNavidadColor={msjNavidadColor}
                        msjDeColor={msjDeColor}
                        msjParaColor={msjParaColor}
                        msjNavidadSize={msjNavidadSize}
                        msjDeSize={msjDeSize}
                        msjParaSize={msjParaSize}
                        msjNavidadFont={msjNavidadFont}
                        msjDeFont={msjDeFont}
                        msjParaFont={msjParaFont}
                        msjNavidadX={msjNavidadX}
                        msjNavidadY={msjNavidadY}
                        msjParaX={msjParaX}
                        msjParaY={msjParaY}
                        msjDeX={msjDeX}
                        msjDeY={msjDeY}
                        selectedId1={selectedId1}
                        selectShape1={selectShape1}
                      />
                    </div>
                  ) : (
                    <Upload setShowCanvas={setShowCanvas} />
                  )}
                </Row>
                {showCanvas ? (
                  <Row
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Button className="christmasCard__botonInputReplace">
                      <label
                        htmlFor="contained-button-file"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                      >
                        <BiImageAdd style={{ marginRight: "8px" }} />
                        <FormattedMessage id="loadPicture" />
                      </label>
                    </Button>
                    <input
                      type="file"
                      accept="image/*"
                      id="contained-button-file"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          setUploadedImage(
                            URL.createObjectURL(e.target.files[0])
                          );
                          const i = new Image();
                          i.onload = function () {
                            const imageDimensions = [
                              {
                                height: i.height,
                                width: i.width,
                              },
                            ];
                            setImgWidth(i.width);
                            setImgHeight(i.height);
                          };

                          i.src = URL.createObjectURL(e.target.files[0]);
                          setShowImage(true);
                          setShowCanvas(true);
                        }
                      }}
                    />
                  </Row>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};
